"use strict";
// tslint:disable
/**
 * Blockstream Esplora API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 * AddressApi - axios parameter creator
 * @export
 */
exports.AddressApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get information about an address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: function (address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'address' is not null or undefined
                    if (address === null || address === undefined) {
                        throw new base_1.RequiredError('address', 'Required parameter address was null or undefined when calling getAddress.');
                    }
                    localVarPath = "/address/{address}"
                        .replace("{" + "address" + "}", encodeURIComponent(String(address)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get transaction history for the specified address, sorted with newest first.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxHistory: function (address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'address' is not null or undefined
                    if (address === null || address === undefined) {
                        throw new base_1.RequiredError('address', 'Required parameter address was null or undefined when calling getAddressTxHistory.');
                    }
                    localVarPath = "/address/{address}/txs"
                        .replace("{" + "address" + "}", encodeURIComponent(String(address)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get unconfirmed transaction history for the specified address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxMempool: function (address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'address' is not null or undefined
                    if (address === null || address === undefined) {
                        throw new base_1.RequiredError('address', 'Required parameter address was null or undefined when calling getAddressTxMempool.');
                    }
                    localVarPath = "/address/{address}/txs/mempool"
                        .replace("{" + "address" + "}", encodeURIComponent(String(address)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the list of unspent transaction outputs associated with the address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressUtxo: function (address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'address' is not null or undefined
                    if (address === null || address === undefined) {
                        throw new base_1.RequiredError('address', 'Required parameter address was null or undefined when calling getAddressUtxo.');
                    }
                    localVarPath = "/address/{address}/utxo"
                        .replace("{" + "address" + "}", encodeURIComponent(String(address)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * AddressApi - functional programming interface
 * @export
 */
exports.AddressApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get information about an address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: function (address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AddressApiAxiosParamCreator(configuration).getAddress(address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get transaction history for the specified address, sorted with newest first.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxHistory: function (address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AddressApiAxiosParamCreator(configuration).getAddressTxHistory(address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get unconfirmed transaction history for the specified address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxMempool: function (address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AddressApiAxiosParamCreator(configuration).getAddressTxMempool(address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of unspent transaction outputs associated with the address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressUtxo: function (address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.AddressApiAxiosParamCreator(configuration).getAddressUtxo(address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AddressApi - factory interface
 * @export
 */
exports.AddressApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get information about an address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: function (address, options) {
            return exports.AddressApiFp(configuration).getAddress(address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get transaction history for the specified address, sorted with newest first.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxHistory: function (address, options) {
            return exports.AddressApiFp(configuration).getAddressTxHistory(address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get unconfirmed transaction history for the specified address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressTxMempool: function (address, options) {
            return exports.AddressApiFp(configuration).getAddressTxMempool(address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of unspent transaction outputs associated with the address.
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressUtxo: function (address, options) {
            return exports.AddressApiFp(configuration).getAddressUtxo(address, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
var AddressApi = /** @class */ (function (_super) {
    __extends(AddressApi, _super);
    function AddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get information about an address.
     * @param {string} address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddress = function (address, options) {
        var _this = this;
        return exports.AddressApiFp(this.configuration).getAddress(address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get transaction history for the specified address, sorted with newest first.
     * @param {string} address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddressTxHistory = function (address, options) {
        var _this = this;
        return exports.AddressApiFp(this.configuration).getAddressTxHistory(address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get unconfirmed transaction history for the specified address.
     * @param {string} address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddressTxMempool = function (address, options) {
        var _this = this;
        return exports.AddressApiFp(this.configuration).getAddressTxMempool(address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of unspent transaction outputs associated with the address.
     * @param {string} address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.getAddressUtxo = function (address, options) {
        var _this = this;
        return exports.AddressApiFp(this.configuration).getAddressUtxo(address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressApi;
}(base_1.BaseAPI));
exports.AddressApi = AddressApi;
/**
 * BlockApi - axios parameter creator
 * @export
 */
exports.BlockApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns information about a block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlock: function (hash, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'hash' is not null or undefined
                    if (hash === null || hash === undefined) {
                        throw new base_1.RequiredError('hash', 'Required parameter hash was null or undefined when calling getBlock.');
                    }
                    localVarPath = "/block/{hash}"
                        .replace("{" + "hash" + "}", encodeURIComponent(String(hash)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the hash of the block currently at height.
         * @param {number} height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockAtHeight: function (height, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'height' is not null or undefined
                    if (height === null || height === undefined) {
                        throw new base_1.RequiredError('height', 'Required parameter height was null or undefined when calling getBlockAtHeight.');
                    }
                    localVarPath = "/block-height/{height}"
                        .replace("{" + "height" + "}", encodeURIComponent(String(height)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the raw block representation in binary.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockRaw: function (hash, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'hash' is not null or undefined
                    if (hash === null || hash === undefined) {
                        throw new base_1.RequiredError('hash', 'Required parameter hash was null or undefined when calling getBlockRaw.');
                    }
                    localVarPath = "/block/{hash}/raw"
                        .replace("{" + "hash" + "}", encodeURIComponent(String(hash)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the block status.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockStatus: function (hash, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'hash' is not null or undefined
                    if (hash === null || hash === undefined) {
                        throw new base_1.RequiredError('hash', 'Required parameter hash was null or undefined when calling getBlockStatus.');
                    }
                    localVarPath = "/block/{hash}/status"
                        .replace("{" + "hash" + "}", encodeURIComponent(String(hash)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the transaction at index :index within the specified block.
         * @param {string} hash
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxByIndex: function (hash, index, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'hash' is not null or undefined
                    if (hash === null || hash === undefined) {
                        throw new base_1.RequiredError('hash', 'Required parameter hash was null or undefined when calling getBlockTxByIndex.');
                    }
                    // verify required parameter 'index' is not null or undefined
                    if (index === null || index === undefined) {
                        throw new base_1.RequiredError('index', 'Required parameter index was null or undefined when calling getBlockTxByIndex.');
                    }
                    localVarPath = "/block/{hash}/txid/{index}"
                        .replace("{" + "hash" + "}", encodeURIComponent(String(hash)))
                        .replace("{" + "index" + "}", encodeURIComponent(String(index)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns a list of all txids in the block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxids: function (hash, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'hash' is not null or undefined
                    if (hash === null || hash === undefined) {
                        throw new base_1.RequiredError('hash', 'Required parameter hash was null or undefined when calling getBlockTxids.');
                    }
                    localVarPath = "/block/{hash}/txids"
                        .replace("{" + "hash" + "}", encodeURIComponent(String(hash)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the hash of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHash: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/blocks/tip/hash";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the height of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeight: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/blocks/tip/height";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * BlockApi - functional programming interface
 * @export
 */
exports.BlockApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returns information about a block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlock: function (hash, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlock(hash, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the hash of the block currently at height.
         * @param {number} height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockAtHeight: function (height, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlockAtHeight(height, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the raw block representation in binary.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockRaw: function (hash, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlockRaw(hash, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the block status.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockStatus: function (hash, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlockStatus(hash, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the transaction at index :index within the specified block.
         * @param {string} hash
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxByIndex: function (hash, index, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlockTxByIndex(hash, index, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of all txids in the block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxids: function (hash, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getBlockTxids(hash, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the hash of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHash: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getLastBlockHash(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the height of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeight: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.BlockApiAxiosParamCreator(configuration).getLastBlockHeight(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BlockApi - factory interface
 * @export
 */
exports.BlockApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returns information about a block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlock: function (hash, options) {
            return exports.BlockApiFp(configuration).getBlock(hash, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the hash of the block currently at height.
         * @param {number} height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockAtHeight: function (height, options) {
            return exports.BlockApiFp(configuration).getBlockAtHeight(height, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the raw block representation in binary.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockRaw: function (hash, options) {
            return exports.BlockApiFp(configuration).getBlockRaw(hash, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the block status.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockStatus: function (hash, options) {
            return exports.BlockApiFp(configuration).getBlockStatus(hash, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the transaction at index :index within the specified block.
         * @param {string} hash
         * @param {number} index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxByIndex: function (hash, index, options) {
            return exports.BlockApiFp(configuration).getBlockTxByIndex(hash, index, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of all txids in the block.
         * @param {string} hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockTxids: function (hash, options) {
            return exports.BlockApiFp(configuration).getBlockTxids(hash, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the hash of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHash: function (options) {
            return exports.BlockApiFp(configuration).getLastBlockHash(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the height of the last block.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeight: function (options) {
            return exports.BlockApiFp(configuration).getLastBlockHeight(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BlockApi - object-oriented interface
 * @export
 * @class BlockApi
 * @extends {BaseAPI}
 */
var BlockApi = /** @class */ (function (_super) {
    __extends(BlockApi, _super);
    function BlockApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns information about a block.
     * @param {string} hash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlock = function (hash, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlock(hash, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the hash of the block currently at height.
     * @param {number} height
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlockAtHeight = function (height, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlockAtHeight(height, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the raw block representation in binary.
     * @param {string} hash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlockRaw = function (hash, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlockRaw(hash, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the block status.
     * @param {string} hash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlockStatus = function (hash, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlockStatus(hash, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the transaction at index :index within the specified block.
     * @param {string} hash
     * @param {number} index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlockTxByIndex = function (hash, index, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlockTxByIndex(hash, index, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of all txids in the block.
     * @param {string} hash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getBlockTxids = function (hash, options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getBlockTxids(hash, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the hash of the last block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getLastBlockHash = function (options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getLastBlockHash(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the height of the last block.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlockApi
     */
    BlockApi.prototype.getLastBlockHeight = function (options) {
        var _this = this;
        return exports.BlockApiFp(this.configuration).getLastBlockHeight(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BlockApi;
}(base_1.BaseAPI));
exports.BlockApi = BlockApi;
/**
 * FeeEstimatesApi - axios parameter creator
 * @export
 */
exports.FeeEstimatesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get an object where the key is the confirmation target (in number of blocks) and the value is the estimated feerate (in sat/vB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimates: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fee-estimates";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * FeeEstimatesApi - functional programming interface
 * @export
 */
exports.FeeEstimatesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get an object where the key is the confirmation target (in number of blocks) and the value is the estimated feerate (in sat/vB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimates: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.FeeEstimatesApiAxiosParamCreator(configuration).getFeeEstimates(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FeeEstimatesApi - factory interface
 * @export
 */
exports.FeeEstimatesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get an object where the key is the confirmation target (in number of blocks) and the value is the estimated feerate (in sat/vB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeEstimates: function (options) {
            return exports.FeeEstimatesApiFp(configuration).getFeeEstimates(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FeeEstimatesApi - object-oriented interface
 * @export
 * @class FeeEstimatesApi
 * @extends {BaseAPI}
 */
var FeeEstimatesApi = /** @class */ (function (_super) {
    __extends(FeeEstimatesApi, _super);
    function FeeEstimatesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get an object where the key is the confirmation target (in number of blocks) and the value is the estimated feerate (in sat/vB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeEstimatesApi
     */
    FeeEstimatesApi.prototype.getFeeEstimates = function (options) {
        var _this = this;
        return exports.FeeEstimatesApiFp(this.configuration).getFeeEstimates(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeeEstimatesApi;
}(base_1.BaseAPI));
exports.FeeEstimatesApi = FeeEstimatesApi;
/**
 * MempoolApi - axios parameter creator
 * @export
 */
exports.MempoolApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get mempool backlog statistics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempool: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mempool";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a list of the last 10 transactions to enter the mempool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolRecent: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mempool/recent";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the full list of txids in the mempool as an array.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolTxids: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mempool/txids";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * MempoolApi - functional programming interface
 * @export
 */
exports.MempoolApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get mempool backlog statistics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempool: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.MempoolApiAxiosParamCreator(configuration).getMempool(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of the last 10 transactions to enter the mempool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolRecent: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.MempoolApiAxiosParamCreator(configuration).getMempoolRecent(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the full list of txids in the mempool as an array.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolTxids: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.MempoolApiAxiosParamCreator(configuration).getMempoolTxids(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * MempoolApi - factory interface
 * @export
 */
exports.MempoolApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get mempool backlog statistics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempool: function (options) {
            return exports.MempoolApiFp(configuration).getMempool(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of the last 10 transactions to enter the mempool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolRecent: function (options) {
            return exports.MempoolApiFp(configuration).getMempoolRecent(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the full list of txids in the mempool as an array.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMempoolTxids: function (options) {
            return exports.MempoolApiFp(configuration).getMempoolTxids(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MempoolApi - object-oriented interface
 * @export
 * @class MempoolApi
 * @extends {BaseAPI}
 */
var MempoolApi = /** @class */ (function (_super) {
    __extends(MempoolApi, _super);
    function MempoolApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get mempool backlog statistics.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MempoolApi
     */
    MempoolApi.prototype.getMempool = function (options) {
        var _this = this;
        return exports.MempoolApiFp(this.configuration).getMempool(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of the last 10 transactions to enter the mempool.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MempoolApi
     */
    MempoolApi.prototype.getMempoolRecent = function (options) {
        var _this = this;
        return exports.MempoolApiFp(this.configuration).getMempoolRecent(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the full list of txids in the mempool as an array.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MempoolApi
     */
    MempoolApi.prototype.getMempoolTxids = function (options) {
        var _this = this;
        return exports.MempoolApiFp(this.configuration).getMempoolTxids(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MempoolApi;
}(base_1.BaseAPI));
exports.MempoolApi = MempoolApi;
/**
 * TxApi - axios parameter creator
 * @export
 */
exports.TxApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns the spending status of all transaction outputs.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTxOutspends: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getAllTxOutspends.');
                    }
                    localVarPath = "/tx/{txId}/outspends"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns information about the transaction.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTx: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTx.');
                    }
                    localVarPath = "/tx/{txId}"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the raw transaction in hex.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHex: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxHex.');
                    }
                    localVarPath = "/tx/{txId}/hex"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using bitcoind\'s merkleblock format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleBlockProof: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxMerkleBlockProof.');
                    }
                    localVarPath = "/tx/{txId}/merkleblock-proof"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using Electrum\'s blockchain.transaction.get_merkle format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleProof: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxMerkleProof.');
                    }
                    localVarPath = "/tx/{txId}/merkle-proof"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the spending status of a transaction output.
         * @param {string} txId
         * @param {number} vout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutspend: function (txId, vout, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxOutspend.');
                    }
                    // verify required parameter 'vout' is not null or undefined
                    if (vout === null || vout === undefined) {
                        throw new base_1.RequiredError('vout', 'Required parameter vout was null or undefined when calling getTxOutspend.');
                    }
                    localVarPath = "/tx/{txId}/outspend/{vout}"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)))
                        .replace("{" + "vout" + "}", encodeURIComponent(String(vout)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the raw transaction as binary data.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxRaw: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxRaw.');
                    }
                    localVarPath = "/tx/{txId}/raw"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the transaction confirmation status.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxStatus: function (txId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'txId' is not null or undefined
                    if (txId === null || txId === undefined) {
                        throw new base_1.RequiredError('txId', 'Required parameter txId was null or undefined when calling getTxStatus.');
                    }
                    localVarPath = "/tx/{txId}/status"
                        .replace("{" + "txId" + "}", encodeURIComponent(String(txId)));
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Broadcast a raw transaction to the network.
         * @param {string} body The transaction should be provided as hex in the request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTx: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new base_1.RequiredError('body', 'Required parameter body was null or undefined when calling postTx.');
                    }
                    localVarPath = "/tx";
                    localVarUrlObj = globalImportUrl.parse(localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'text/plain';
                    localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, headersFromBaseOptions, options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: globalImportUrl.format(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * TxApi - functional programming interface
 * @export
 */
exports.TxApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returns the spending status of all transaction outputs.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTxOutspends: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getAllTxOutspends(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns information about the transaction.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTx: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTx(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the raw transaction in hex.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHex: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxHex(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using bitcoind\'s merkleblock format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleBlockProof: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxMerkleBlockProof(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using Electrum\'s blockchain.transaction.get_merkle format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleProof: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxMerkleProof(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the spending status of a transaction output.
         * @param {string} txId
         * @param {number} vout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutspend: function (txId, vout, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxOutspend(txId, vout, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the raw transaction as binary data.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxRaw: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxRaw(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the transaction confirmation status.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxStatus: function (txId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).getTxStatus(txId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Broadcast a raw transaction to the network.
         * @param {string} body The transaction should be provided as hex in the request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTx: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TxApiAxiosParamCreator(configuration).postTx(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TxApi - factory interface
 * @export
 */
exports.TxApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returns the spending status of all transaction outputs.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTxOutspends: function (txId, options) {
            return exports.TxApiFp(configuration).getAllTxOutspends(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns information about the transaction.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTx: function (txId, options) {
            return exports.TxApiFp(configuration).getTx(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the raw transaction in hex.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHex: function (txId, options) {
            return exports.TxApiFp(configuration).getTxHex(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using bitcoind\'s merkleblock format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleBlockProof: function (txId, options) {
            return exports.TxApiFp(configuration).getTxMerkleBlockProof(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a merkle inclusion proof for the transaction using Electrum\'s blockchain.transaction.get_merkle format.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxMerkleProof: function (txId, options) {
            return exports.TxApiFp(configuration).getTxMerkleProof(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the spending status of a transaction output.
         * @param {string} txId
         * @param {number} vout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxOutspend: function (txId, vout, options) {
            return exports.TxApiFp(configuration).getTxOutspend(txId, vout, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the raw transaction as binary data.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxRaw: function (txId, options) {
            return exports.TxApiFp(configuration).getTxRaw(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the transaction confirmation status.
         * @param {string} txId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxStatus: function (txId, options) {
            return exports.TxApiFp(configuration).getTxStatus(txId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Broadcast a raw transaction to the network.
         * @param {string} body The transaction should be provided as hex in the request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTx: function (body, options) {
            return exports.TxApiFp(configuration).postTx(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TxApi - object-oriented interface
 * @export
 * @class TxApi
 * @extends {BaseAPI}
 */
var TxApi = /** @class */ (function (_super) {
    __extends(TxApi, _super);
    function TxApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns the spending status of all transaction outputs.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getAllTxOutspends = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getAllTxOutspends(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns information about the transaction.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTx = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTx(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the raw transaction in hex.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxHex = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxHex(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a merkle inclusion proof for the transaction using bitcoind\'s merkleblock format.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxMerkleBlockProof = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxMerkleBlockProof(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a merkle inclusion proof for the transaction using Electrum\'s blockchain.transaction.get_merkle format.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxMerkleProof = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxMerkleProof(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the spending status of a transaction output.
     * @param {string} txId
     * @param {number} vout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxOutspend = function (txId, vout, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxOutspend(txId, vout, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the raw transaction as binary data.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxRaw = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxRaw(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the transaction confirmation status.
     * @param {string} txId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.getTxStatus = function (txId, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).getTxStatus(txId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Broadcast a raw transaction to the network.
     * @param {string} body The transaction should be provided as hex in the request body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    TxApi.prototype.postTx = function (body, options) {
        var _this = this;
        return exports.TxApiFp(this.configuration).postTx(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TxApi;
}(base_1.BaseAPI));
exports.TxApi = TxApi;
